
  import {createControllersWithDescriptors, initAppForPageWrapper} from '@wix/yoshi-flow-editor/runtime/esm/viewerScript/wrapper.js';
  
  
            
import wrapController0 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller0 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/cookieManager/viewer.controller.ts';
            import * as _controllerExport0 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/cookieManager/model.ts';
            var controllerExport0 = _controllerExport0;
            

            
import wrapController1 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller1 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/copyText/viewer.controller.ts';
            import * as _controllerExport1 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/copyText/model.ts';
            var controllerExport1 = _controllerExport1;
            

            
import wrapController2 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller2 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/notificationBanner/viewer.controller.ts';
            import * as _controllerExport2 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/notificationBanner/model.ts';
            var controllerExport2 = _controllerExport2;
            

            
import wrapController3 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller3 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referFriendPage/viewer.controller.ts';
            import * as _controllerExport3 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referFriendPage/model.ts';
            var controllerExport3 = _controllerExport3;
            

            
import wrapController4 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller4 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referFriendPageContent/viewer.controller.ts';
            import * as _controllerExport4 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referFriendPageContent/model.ts';
            var controllerExport4 = _controllerExport4;
            

            
import wrapController5 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller5 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referralPage/viewer.controller.ts';
            import * as _controllerExport5 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referralPage/model.ts';
            var controllerExport5 = _controllerExport5;
            

            
import wrapController6 from '@wix/yoshi-flow-editor-runtime/internal/viewerScript/blocks';

            import controller6 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referralPageContent/viewer.controller.ts';
            import * as _controllerExport6 from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referralPageContent/model.ts';
            var controllerExport6 = _controllerExport6;
            

  
  var importedApp = {};


  

    import { initState, initBind } from '@wix/yoshi-flow-editor/runtime/esm/velocycleMobx';
    import { observable } from 'mobx';
    var velocycleMobx = { initState, initBind, observable };
    


  

    import { blocksControllerService } from '@wix/yoshi-flow-editor/runtime/esm/blocks/controllerService'
    

  
var createHttpClient = null;

  

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


  
const multilingualDisabled = false;

  

    var createExperiments = null;
    var createWidgetExperiments = null;
    


  var sentryConfig = {
      DSN: 'https://d60168e628f54a928ccf72b4e42d8eb1@sentry-next.wixpress.com/20199',
      id: 'undefined',
      projectName: 'referrals-tpa',
      teamName: 'loyalty',
      errorMonitor: true,
    };

  var experimentsConfig = {"centralized":true,"scopes":[]};

  var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};

  var defaultTranslations = {"install-progress-panel.title":"Adding Wix Referral Program","install-progress-panel.step.preparing":"Preparing your layout...","install-progress-panel.step.configuring":"Configuring your components...","install-progress-panel.step.optimizing":"Optimizing your pages...","install-progress-panel.step.done":"You're good to go","pages.tab":"Referral Pages","pages.title.refer-friend":"Refer Friends","pages.title.referral":"Referral Landing Page","pages.settings.seo-basics":"SEO Basics","pages.action.delete-app":"Delete Referrals","pages.action.delete":"Delete","pages.action.manage":"Manage Referrals","gfpp.manage-program":"Manage Program","gfpp.change-design":"Change Design","gfpp.switch-state":"Switch State","status.not-available":"The referral program is not available.","units.px":"px","refer-friend-page.element.title":"Title","refer-friend-page.element.image":"Image","refer-friend-page.element.image-container":"Image Background","refer-friend-page.element.subtitle":"Subtitle","refer-friend-page.element.description":"Reward description","refer-friend-page.element.explanations":"Terms and conditions","refer-friend-page.element.divider":"Divider","refer-friend-page.element.copy-link-text":"‘Copy link’ note","refer-friend-page.element.share-text":"‘Share it’ note","refer-friend-page.element.social-bar":"Share buttons","refer-friend-page.element.notificationTitle":"Title","refer-friend-page.element.notificationDescription":"Description","refer-friend-page.element.content":"Content Box","refer-friend-page.element-category.notification":"Banner","refer-friend-page.element-category.program-info":"Program Info","refer-friend-page.element-category.copy-and-share":"Copy and Share","refer-friend-page.notification.title-points":"You have {count, plural, one {{formattedCount} point} other {{formattedCount} points}}","refer-friend-page.notification.title-points.custom":"You have {formattedCount} {pointsName}","refer-friend-page.notification.description-coupon":"Apply reward when placing your first order.","refer-friend-page.notification.description-points":"Redeem your points for rewards and place your first order.","refer-friend-page.state.logged-in":"Customer logged in","refer-friend-page.state.logged-out":"Customer logged out","refer-friend-page.state.notification":"Friend visits page","refer-friend-page.design.title":"Refer Friends Design","refer-friend-page.design.presets-title":"Discover More Designs","refer-friend-page.design.tab.main-title":"Title","refer-friend-page.design.tab.subtitle":"Subtitle","refer-friend-page.design.tab.body-text":"Body Text","refer-friend-page.design.tab.button":"Button","refer-friend-page.design.tab.secondary-text":"Secondary Text","refer-friend-page.design.tab.box-background":"Box Background","refer-friend-page.design.tab.image-background":"Image Background","refer-friend-page.design.tab.notification-background":"Banner Background","refer-friend-page.text-input-area-label":"Copy your referral link","referral-page.element.title":"Title","referral-page.element.image":"Image","referral-page.element.image-container":"Image Container","referral-page.element.subtitle":"Subtitle","referral-page.element.explanations":"Terms and conditions","referral-page.element.divider":"Divider","referral-page.element.apply-code-text":"‘Apply code’ note","referral-page.element.my-rewards-text":"'Find code' note","referral-page.element.content":"Content Box","referral-page.get-reward":"Get Reward","referral-page.go-to-home":"Go to Home","referral-page.not-eligible.title":"You’re already a member","referral-page.not-eligible.description":"Referral rewards apply to new members only.","referral-page.not-eligible.go-to-rewards":"Go to My Rewards","referral-page.timeout-error.title":"There’s an issue with your reward","referral-page.timeout-error.description":"Try reloading the page or check back again later.","referral-page.title.points":"You have {count, plural, one {{formattedCount} point} other {{formattedCount} points}}","referral-page.title.points.custom":"You have {formattedCount} {pointsName}","referral-page.title.points.empty":"You’ve already used your reward.","referral-page.subtitle.apply-reward":"Apply reward when placing your first order.","referral-page.subtitle.redeem-points":"Go to your Rewards page to redeem points for rewards.","referral-page.subtitle.start-browsing":"Start browsing and place your first order.","referral-page.my-rewards-text":"You can also find this code on the <1>Rewards</1> page.","referral-page.state.logged-in":"Friend logged in","referral-page.state.logged-out":"Friend logged out","referral-page.design.title":"Landing Page Design","referral-page.design.tab.title":"Title","referral-page.design.tab.body-text":"Body Text","referral-page.design.tab.secondary-text":"Secondary Text","referral-page.design.tab.button":"Button","referral-page.design.tab.box-background":"Box Background","referral-page.design.tab.image-background":"Image Background","referral-page.text-input-area-label":"Apply code at checkout","switch-state-panel.title":"Switch State","switch-state-panel.select-state":"Select state","switch-state-panel.description.refer-friend-page":"Check what your page looks like when your customer is logged in, logged out, and when their referred friend visits this page.","switch-state-panel.description.referral-page":"Check what your page looks like when a referred friend is logged in and logged out.","layout-panel.title":"Layout","layout-panel.top-spacing":"Top padding","layout-panel.bottom-spacing":"Bottom padding","layout-panel.horizontal-spacing":"Left and right padding","layout-panel.errors.enter-number":"Enter a number.","layout-panel.alignment":"Alignment","layout-panel.alignment.left":"Left","layout-panel.alignment.center":"Center","layout-panel.alignment.right":"Right","default-blocks-text.apply-code":"Apply code at checkout","default-blocks-text.log-in":"Log in to refer","default-blocks-text.get-special-perks":"Get special perks for you and your friends","default-blocks-text.copy-link":"Copy your referral link","default-blocks-text.share-it":"Share it with anyone","default-blocks-text.copy":"Copy","default-blocks-text.get-reward":"Get Reward","my-business-panel.upgrade-text":"To run a referral program, ","my-business-panel.upgrade-link-text":"upgrade your plan.","my-business-panel.view-dashboard":"Go to Dashboard","my-business-panel.manage-program":"Manage Program","my-business-panel.manage-referral-pages":"Manage Referral Pages","my-business-panel.manage-emails":"Manage Email Automations","my-business-panel.customize-referrals-page":"Customize Referral Page","panel.bp.banner.desktop-and-tablet":"Changes apply to desktop and tablet.","panel.bp.banner.cascades":"Changes will cascade to lower breakpoints.","panel.bp.banner.all":"Changes apply to all breakpoints.","panel.bp.banner.mobile":"Changes apply to mobile only.","panel.bp.learn-more":"Learn more","panel.bp.learn-more.link":"https://support.wix.com/en/article/working-with-breakpoints","copy-text.aria-label.copied":"Copied to clipboard","copy-text.aria-label.copy":"Copy to clipboard"};

  var fedopsConfig = null;

  import { createVisitorBILogger as biLogger } from '/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/target/generated/bi/createBILogger.ts';

  export const exports = importedApp.exports;

  export const initAppForPage = initAppForPageWrapper({
    initAppForPage: importedApp.initAppForPage,
    sentryConfig: sentryConfig,
    experimentsConfig: experimentsConfig,
    inEditor: false,
    biLogger: biLogger,
    multilingualDisabled,
    projectName: "referrals-tpa",
    biConfig: null,
    appName: "Wix Referral Program",
    appDefinitionId: "58be0514-fc10-4eb1-886e-2909d18f33b3",
    fedopsConfig: fedopsConfig,
    translationsConfig: translationsConfig,
    defaultTranslations: defaultTranslations,
    shouldUseEssentials: true,
    optionalDeps: {
      initI18n,
      createHttpClient,
      createExperiments,
    },
    localeDistPath: "assets/locales",
  });

  const _createControllers = createControllersWithDescriptors({
    initI18n,
    blocksControllerService,
    createHttpClient,
    createExperiments,
    velocycleMobx,
  }, [{ method: controller0,
          wrap: wrapController0,
          exports: controllerExport0,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/cookieManager/viewer.controller.ts",
          appName: "Wix Referral Program",
          appDefinitionId: "58be0514-fc10-4eb1-886e-2909d18f33b3",
          projectName: "referrals-tpa",
          componentName: "cookieManager",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "58be0514-fc10-4eb1-886e-2909d18f33b3-om81f" }, { method: controller1,
          wrap: wrapController1,
          exports: controllerExport1,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/copyText/viewer.controller.ts",
          appName: "Wix Referral Program",
          appDefinitionId: "58be0514-fc10-4eb1-886e-2909d18f33b3",
          projectName: "referrals-tpa",
          componentName: "copyText",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "58be0514-fc10-4eb1-886e-2909d18f33b3-jr8f3" }, { method: controller2,
          wrap: wrapController2,
          exports: controllerExport2,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/notificationBanner/viewer.controller.ts",
          appName: "Wix Referral Program",
          appDefinitionId: "58be0514-fc10-4eb1-886e-2909d18f33b3",
          projectName: "referrals-tpa",
          componentName: "notificationBanner",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "58be0514-fc10-4eb1-886e-2909d18f33b3-cob79" }, { method: controller3,
          wrap: wrapController3,
          exports: controllerExport3,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referFriendPage/viewer.controller.ts",
          appName: "Wix Referral Program",
          appDefinitionId: "58be0514-fc10-4eb1-886e-2909d18f33b3",
          projectName: "referrals-tpa",
          componentName: "referFriendPage",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "58be0514-fc10-4eb1-886e-2909d18f33b3-gliwu" }, { method: controller4,
          wrap: wrapController4,
          exports: controllerExport4,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referFriendPageContent/viewer.controller.ts",
          appName: "Wix Referral Program",
          appDefinitionId: "58be0514-fc10-4eb1-886e-2909d18f33b3",
          projectName: "referrals-tpa",
          componentName: "referFriendPageContent",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "58be0514-fc10-4eb1-886e-2909d18f33b3-rfdex" }, { method: controller5,
          wrap: wrapController5,
          exports: controllerExport5,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referralPage/viewer.controller.ts",
          appName: "Wix Referral Program",
          appDefinitionId: "58be0514-fc10-4eb1-886e-2909d18f33b3",
          projectName: "referrals-tpa",
          componentName: "referralPage",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "58be0514-fc10-4eb1-886e-2909d18f33b3-qm8i4" }, { method: controller6,
          wrap: wrapController6,
          exports: controllerExport6,
          widgetType: "BLOCKS_WIDGET",
          translationsConfig,
          multilingualDisabled,
          experimentsConfig: {"centralized":true,"scopes":[]},
          fedopsConfig: fedopsConfig,
          sentryConfig: sentryConfig,
          persistentAcrossPages: false,
          biLogger: biLogger,
          shouldUseEssentials: true,
          withErrorBoundary: false,
          biConfig: null,
          controllerFileName: "/home/builduser/work/63eafda0c4b1d674/packages/referrals-tpa/src/components/referralPageContent/viewer.controller.ts",
          appName: "Wix Referral Program",
          appDefinitionId: "58be0514-fc10-4eb1-886e-2909d18f33b3",
          projectName: "referrals-tpa",
          componentName: "referralPageContent",
          localeDistPath: "assets/locales",
          defaultTranslations: defaultTranslations,
          id: "58be0514-fc10-4eb1-886e-2909d18f33b3-gn3u0" }],
    false);

    export const createControllers = _createControllers
